import React, { useEffect, useRef } from "react";

export default function AdSlot({ slot }) {
  const ref = useRef(null);

  const push = () => {
    if (!window.hasAdsConsent || !ref.current) return;
    if (ref.current.getAttribute("data-adsbygoogle-status") === "done") return;
    try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch {}
  };

  useEffect(() => { push(); }, [slot]);
  useEffect(() => {
    window.addEventListener("ads-consent-granted", push);
    return () => window.removeEventListener("ads-consent-granted", push);
  }, [slot]);

  return (
    <ins
      ref={ref}
      className="adsbygoogle"
      style={{ display: "block", minHeight: 250 }}
      data-ad-client="ca-pub-2416698434185002"
      data-ad-slot={slot}
      data-ad-format="auto"                  // ← NOT responsive
      data-full-width-responsive="true"
      data-adtest="off"                   // ← keep ON on localhost
    />
  );
}
